export default "__VITE_ASSET__fb86e270__"